var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSheetImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 69.389,
    height: 87.849,
    viewBox: "0 0 69.389 87.849",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{clip-path:url(#h);}.c{clip-path:url(#j);}.d{clip-path:url(#l);}.e{clip-path:url(#n);}.f{clip-path:url(#p);}.g{clip-path:url(#r);}.h{clip-path:url(#t);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff5f45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff357d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M53.011,6.579l10.5,11.829h-10.5ZM11.341,84.229c-4.691,0-7.708-3.034-7.708-7.737q0-32.634,0-65.268c0-3.811,1.978-6.522,5.461-7.438a8.159,8.159,0,0,1,2.036-.219q18.7-.018,37.394-.007c.223,0,.447.024.779.044V6.519q0,6.518,0,13.036c0,1.784.641,2.422,2.424,2.424q6.475,0,12.95,0h1.071v.856q0,26.888,0,53.775a7.117,7.117,0,0,1-5.38,7.335,8.691,8.691,0,0,1-2.285.275q-14.356.014-28.71.013-9.016,0-18.032,0M50.789,0c-1.858.02-3.717.006-5.575.006Q28.189.006,11.165,0A10.918,10.918,0,0,0,0,11.321Q.022,43.912.007,76.5c0,.285,0,.571.014.857a10.5,10.5,0,0,0,6,9.311,23.669,23.669,0,0,0,3.452,1.177H59.912a1.274,1.274,0,0,1,.3-.141,10.753,10.753,0,0,0,9.159-10.947q.023-28.047.019-56.091a2.7,2.7,0,0,0-.728-1.927Q60.688,9.824,52.744.879A2.429,2.429,0,0,0,50.855,0Z",
    transform: "translate(0)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M61.137,75.413q-20.664,0-41.327,0a4.929,4.929,0,0,0-1.1.116,1.76,1.76,0,0,0,.069,3.439,6.565,6.565,0,0,0,1.192.091q10.246.009,20.492,0,10.417,0,20.835,0c1.46,0,2.3-.712,2.281-1.865-.019-1.13-.82-1.759-2.269-1.784h-.172",
    transform: "translate(-17.355 -75.413)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M19.886,61.556a6.108,6.108,0,0,0-1.108.077,1.759,1.759,0,0,0-.07,3.438,5.913,5.913,0,0,0,1.272.121q10.2.011,20.406,0,10.289,0,20.578,0a5.792,5.792,0,0,0,1.022-.065,1.8,1.8,0,0,0,1.591-1.82,1.755,1.755,0,0,0-1.764-1.732c-.255-.025-.514-.024-.771-.024H44.151q-12.132,0-24.265,0",
    transform: "translate(-17.356 -61.553)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M19.683,47.488c-1.472,0-2.326.673-2.335,1.812s.826,1.8,2.313,1.817c.2,0,.4,0,.6,0H40.4q10.288,0,20.573,0a6.638,6.638,0,0,0,1.2-.067,1.767,1.767,0,0,0,.18-3.409,3.934,3.934,0,0,0-1.1-.147q-12.831-.007-25.66-.006l-15.914,0",
    transform: "translate(-17.348 -47.486)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M19.916,89.309c-1.7,0-2.575.632-2.565,1.839s.849,1.792,2.594,1.792H40.518q10.243,0,20.487,0a6.828,6.828,0,0,0,1.11-.058,1.778,1.778,0,0,0,1.458-1.674,1.755,1.755,0,0,0-1.245-1.748,4.915,4.915,0,0,0-1.267-.144q-13.716-.007-27.43-.006H19.916",
    transform: "translate(-17.351 -89.308)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M27.144,28.69c-2.571,0-5.143-.008-7.715,0a1.82,1.82,0,0,0-2,1.382c-.287,1.268.54,2.219,1.988,2.225,3.6.015,7.2.006,10.8.006q.708,0,1.418,0c1.128.005,2.256.01,3.383-.016a1.752,1.752,0,0,0,1.835-2.137c-.156-.947-.822-1.458-2-1.464q-1.6-.009-3.193-.008-2.261,0-4.523,0",
    transform: "translate(-17.375 -28.687)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M19.494,102.94a3.282,3.282,0,0,0-.765.067,1.777,1.777,0,0,0-1.246,2.4,1.945,1.945,0,0,0,2.018,1.146c2.54-.008,5.081,0,7.621,0l2.361,0c1.782,0,3.564,0,5.346-.006a1.836,1.836,0,0,0,2.068-1.8c0-1.078-.854-1.807-2.161-1.809q-3.333,0-6.666,0-4.289,0-8.577,0",
    transform: "translate(-17.345 -102.936)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 69.393,
    height: 87.849,
    transform: "translate(-0.003 -0.001)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.107 48.261)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 46.26,
    height: 3.66,
    transform: "translate(-0.018 -0.001)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.107 39.392)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "d"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 46.26,
    height: 3.647,
    transform: "translate(-0.02 -0.001)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.102 30.389)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "e"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 46.283,
    height: 3.634,
    transform: "translate(-0.009)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.104 57.154)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "f"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 46.271,
    height: 3.633,
    transform: "translate(-0.01)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.12 18.359)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "g"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 19.909,
    height: 3.639,
    transform: "translate(-0.231 -0.005)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.1 65.875)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "h"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 19.844,
    height: 3.624,
    transform: "translate(-0.289 0)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSheetImage);
export default __webpack_public_path__ + "static/media/sheetImage.8c722a53b52597822530190ad6d64355.svg";
export { ForwardRef as ReactComponent };